import'./header-bar.scss'

/**
 *  Component Definition
 *
 * @export
 * @class HeaderBar
 * @implements {ng.IComponentOptions}
 */
export class HeaderBar implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: ng.IControllerConstructor = HeaderBarController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./header-bar.html').toString()

  /**
   * Object containing pairs Directive Bindings for Component
   *
   * @type {Object}
   */
  public bindings: { [binding: string]: string; } = {
    screenController: '='
  }
}

/**
 * HeaderBar - Controller
 *
 * @export
 * @class HeaderBarController
 */
export class HeaderBarController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'AngularServices', 'AppServices']
  public screenController
  public logo
  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public AngularServices: any, public AppServices: any) {
    this.$log = $log.getInstance('HeaderBar', false);
    this.$log.debug('constructor')

    this.logo = `data:image/svg+xml;utf8,<svg id="Topbar_Marvel" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 40"><defs><style>.cls-1{fill:%23ec1c24;}.cls-2{fill:%23fff;}</style></defs><title>Topbar_Marvel</title><g id="Marvel_Logo" data-name="Marvel Logo"><rect class="cls-1" width="94.53" height="38.29"/><path class="cls-2" d="M549.77,438.08l-2.63-19.42H541.3l0.65,5.18a9.22,9.22,0,0,0-8.32-5.18H527.8l0,28.31-4.25-28.31h-7.64L511.48,448V418.66h-7.31l-2.63,16.48L499,418.66h-7.32v31.89h5.76V435.18L500,450.55h3.06l2.58-15.37v15.37h11.1l0.68-4.9h4.47l0.67,4.9h10.93V440.2l1.33-.19,2.77,10.55h5.65l-3.63-12.37a9.24,9.24,0,0,0,3.36-8.12h0l3.43,20.51,6.71,0,4.58-28.9v28.9h10.87v-5.74h-5.16V437.5h5.16v-5.82h-5.16v-7.2h5.16v-5.81H552.43Zm-31.63,2.5L519.72,427l1.64,13.63h-3.22Zm16.74-6.3a3.13,3.13,0,0,1-1.35.32V424.36h0c0.45,0,3.82.13,3.82,5.07C537.37,432,536.22,433.64,534.88,434.29Zm40.43,10.52h4.9v5.73H569.6V418.66h5.71v26.15Z" transform="translate(-488.63 -415.35)"/></g></svg>`
  }

  /**
   * life cycle hooks (road to ng2)
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit(): void {
    this.$log.debug('onInit')
  }

  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges', changesObj)
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/header-bar/header-bar.ts
 **/